import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  profile,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  required,
  toFixed,
  Navbar,
  Modal,
  Pagination,
} from "../../components/CustomComponent.js";
import LOGOLARGE from "../../assets/images/logo512.png";

const PAGE_SIZE = 20;

/**
 * จัดการสินค้า Marketplace (super_user หรือ role ที่มีสิทธิ์ products.*)
 * แก้ชื่อ รูป (URL) ราคา ประเภท หมายเหตุ ผ่าน v1/admin/products
 */
export default class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      // มุมมองรายการ: ตาราง หรือ การ์ด (จำค่าไว้ใน localStorage)
      view_mode: localStorage.getItem("product_view_mode") === "card" ? "card" : "table",
      preview: null,

      data: [],
      count: 0,
      page: 1,
      loaded: false,

      uid: "",
      product_code: "",
      product_type: "",
      product_name: "",
      product_image: "",
      price: "",
      sold: "",
      remark: "",
    };
    this.zoom_ref = React.createRef();
  }

  async componentDidMount() {
    // super_user เข้าได้เสมอ role อื่นต้องมีสิทธิ์ products.read ไม่งั้นเด้งกลับหน้าแรก
    const canRead = profile?.user_type === "super_user" || (profile?.role?.permission || []).includes("products.read");
    if (!canRead) {
      window.location.href = "/";
      return;
    }
    loading(false);
    await this.Get(1);
  }

  Get = async (page = 1) => {
    const { filter_search } = this.state;
    loading(true);
    let [result] = await Promise.all([
      GET("v1/admin/products", {
        data_search: filter_search,
        page,
        page_size: PAGE_SIZE,
      }),
    ]);
    if (result?.status) {
      this.setState({
        data: Array.isArray(result.data) ? result.data : [],
        count: result.pagination?.count || 0,
        page,
        loaded: true,
      });
    } else {
      this.setState({ data: [], count: 0, page, loaded: true });
    }
    loading(false);
  };

  OpenCreate = () => {
    this.setState({
      uid: "",
      product_code: "",
      product_type: "",
      product_name: "",
      product_image: "",
      price: "",
      sold: "",
      remark: "",
      modal_create: true,
    });
  };

  OpenUpdate = (item) => {
    this.setState({
      uid: item.uid || "",
      product_code: item.product_code || "",
      product_type: item.product_type || "",
      product_name: item.product_name || "",
      product_image: item.product_image || "",
      price: item.price ?? "",
      sold: item.sold ?? "",
      remark: item.remark || "",
      modal_update: true,
    });
  };

  CreateUpdate = async () => {
    const { uid, product_type, product_name, product_image, price, sold, remark } = this.state;

    if (!product_name.trim()) {
      alert("", "warning", "Warning", "Please input Product Name");
      return;
    }
    if (price === "" || isNaN(Number(price)) || Number(price) < 0) {
      alert("", "warning", "Warning", "Please input a valid Price");
      return;
    }
    if (sold !== "" && (isNaN(Number(sold)) || Number(sold) < 0)) {
      alert("", "warning", "Warning", "Sold must be a number");
      return;
    }
    if (product_image && !/^https?:\/\//i.test(product_image.trim())) {
      alert("", "warning", "Warning", "Image must be a URL starting with http:// or https://");
      return;
    }

    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      // DTO ฝั่ง backend เป็น strict ส่งเฉพาะ field ที่อนุญาต และ price/sold ต้องเป็น number
      let body = {
        product_type: product_type.trim(),
        product_name: product_name.trim(),
        product_image: product_image.trim(),
        price: Number(price),
        remark: remark.trim(),
      };
      if (sold !== "") body.sold = Number(sold);

      let result = !uid
        ? await POST("v1/admin/products", body)
        : await PUT("v1/admin/products/" + uid, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };

  Delete = async (item) => {
    if (
      await alert(
        "",
        "warning",
        "Delete Item",
        `Do you really want to delete "${item.product_name || item.product_code}"?`,
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let result = await DELETE("v1/admin/products/" + item.uid, null);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };

  SetView = (view_mode) => {
    try {
      localStorage.setItem("product_view_mode", view_mode);
    } catch (e) {
      // โหมด private บางเบราว์เซอร์เขียน localStorage ไม่ได้ ไม่ต้องล้ม
    }
    this.setState({ view_mode, preview: null });
  };

  // ตำแหน่งภาพขยาย เกาะเมาส์แต่ไม่ให้ทะลุขอบจอ
  PreviewPosition = (e) => {
    const SIZE = 320;
    const GAP = 18;
    let x = e.clientX + GAP;
    let y = e.clientY - SIZE / 2;
    if (x + SIZE > window.innerWidth - GAP) x = e.clientX - SIZE - GAP;
    if (x < GAP) x = GAP;
    if (y + SIZE > window.innerHeight - GAP) y = window.innerHeight - SIZE - GAP;
    if (y < GAP) y = GAP;
    return { x, y };
  };

  ShowPreview = (e, item) => {
    // อุปกรณ์สัมผัสไม่มี hover จริง เปิดแล้วจะค้าง
    if (window.matchMedia && window.matchMedia("(hover: none)").matches) return;
    const { x, y } = this.PreviewPosition(e);
    this.setState({
      preview: {
        src: item.product_image || LOGOLARGE,
        name: item.product_name || "",
        x,
        y,
      },
    });
  };

  // ขยับกล่องตามเมาส์ด้วย ref ตรงๆ ไม่ setState ทุก mousemove (จะ re-render ทั้งรายการ)
  MovePreview = (e) => {
    if (!this.state.preview || !this.zoom_ref.current) return;
    const { x, y } = this.PreviewPosition(e);
    this.zoom_ref.current.style.left = x + "px";
    this.zoom_ref.current.style.top = y + "px";
  };

  HidePreview = () => {
    if (this.state.preview) this.setState({ preview: null });
  };

  RenderThumb = (item, size) => (
    <div
      className="pu-thumb"
      style={size ? { width: size, height: size } : undefined}
      onMouseEnter={(e) => this.ShowPreview(e, item)}
      onMouseMove={this.MovePreview}
      onMouseLeave={this.HidePreview}
    >
      <img
        alt={item.product_name || "product"}
        src={item.product_image || LOGOLARGE}
        onError={this.handleImgError}
      />
      <span className="pu-thumb-zoom icon">{"\uf00e"}</span>
    </div>
  );

  handleImgError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = LOGOLARGE;
  };

  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      view_mode,
      preview,
      data,
      count,
      page,
      loaded,

      product_code,
      product_type,
      product_name,
      product_image,
      price,
      sold,
      remark,
    } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const closeModal = () => this.setState({ modal_create: false, modal_update: false });
    const start_index = count ? (page - 1) * PAGE_SIZE + 1 : 0;
    const end_index = Math.min(page * PAGE_SIZE, count);

    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Marketplace</div>
                <div className="ar-title">Product Management</div>
                <div className="ar-subtitle">
                  Update product name, image, price and details shown on the marketplace.
                </div>
              </div>
              <div className="ar-hero-actions">
                <button className="ar-btn-gold" onClick={this.OpenCreate}>
                  <span className="icon me-2">{""}</span>Create Product
                </button>
                <div className="text-end ms-2 d-none d-md-block">
                  <div className="ar-year">{count.toLocaleString("en-US")}</div>
                  <div className="ar-year-caption justify-content-end">
                    product{count === 1 ? "" : "s"}
                  </div>
                </div>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
              <input
                type="text"
                className="form-control"
                placeholder="Search name, code, type, image URL, remark, price..."
                onChange={(e) => this.setState({ filter_search: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === "Enter") this.Get(1);
                }}
                value={filter_search}
              />
                </div>
              <div className="ar-toolbar-actions">
              <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                <span className="icon me-2">{""}</span>Search
              </button>
              <button
                className="ar-btn-ghost"
                onClick={() => this.setState({ filter_search: "" }, () => this.Get(1))}
              >
                Reset
              </button>
              </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">Products</div>
                <div className="ar-table-caption">
                  {count ? `Showing ${start_index}-${end_index} of ${count.toLocaleString("en-US")}` : "No products"}
                </div>
              </div>
              <div className="pu-viewtoggle" role="group" aria-label="View mode">
                <button
                  type="button"
                  className={"pu-viewbtn" + (view_mode === "table" ? " active" : "")}
                  onClick={() => this.SetView("table")}
                  title="Table view"
                >
                  <span className="icon me-2">{"\uf00b"}</span>Table
                </button>
                <button
                  type="button"
                  className={"pu-viewbtn" + (view_mode === "card" ? " active" : "")}
                  onClick={() => this.SetView("card")}
                  title="Card view"
                >
                  <span className="icon me-2">{"\uf00a"}</span>Cards
                </button>
              </div>
            </div>
            {view_mode === "table" ? (
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-80">Image</td>
                    <td className="text-nowrap wpx-110">Code</td>
                    <td className="text-nowrap">Name</td>
                    <td className="text-nowrap wpx-140">Type</td>
                    <td className="text-nowrap text-end wpx-120">Price</td>
                    <td className="text-nowrap text-end wpx-90">Sold</td>
                    <td className="text-center text-nowrap td-actions">Actions</td>
                  </tr>
                </thead>
                <tbody>
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={7} className="text-center text-secondary py-5">
                        No products found
                      </td>
                    </tr>
                  )}
                  {rows.map((item, index) => (
                    <tr key={item.uid || `product-${index}`}>
                      <td data-label="Image">{this.RenderThumb(item, 56)}</td>
                      <td data-label="Code" className="text-nowrap fw-semibold">
                        {item.product_code || "-"}
                      </td>
                      <td data-label="Name">
                        <div
                          className="text-truncate"
                          style={{ minWidth: 200, maxWidth: 360 }}
                          title={item.product_name || ""}
                        >
                          {item.product_name || "-"}
                        </div>
                      </td>
                      <td data-label="Type" className="text-nowrap">
                        {item.product_type || "-"}
                      </td>
                      <td data-label="Price" className="text-nowrap text-end fw-bold">
                        {toFixed(Number(item.price) || 0, 2)}
                      </td>
                      <td data-label="Sold" className="text-nowrap text-end">
                        {(Number(item.sold) || 0).toLocaleString("en-US")}
                      </td>
                      <td data-label="Actions" className="text-center text-nowrap td-actions">
                        <Dropdown align="end">
                          <Dropdown.Toggle className="pu-action-toggle" id={`product-actions-${index}`}>Action</Dropdown.Toggle>
                          <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                            <Dropdown.Item className="pu-action-item" onClick={() => this.OpenUpdate(item)}>
                              <span className="icon">{""}</span>Edit
                            </Dropdown.Item>
                            <div className="pu-action-sep" />
                            <Dropdown.Item className="pu-action-item danger" onClick={() => this.Delete(item)}>
                              <span className="icon">{""}</span>Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            ) : (
            <div className="pu-cards p-3">
              {loaded && rows.length === 0 && (
                <div className="text-center text-secondary py-5">No products found</div>
              )}
              <div className="pu-cards-grid">
                {rows.map((item, index) => (
                  <div key={item.uid || `product-card-${index}`}>
                    <div className="pu-pcard">
                      {this.RenderThumb(item)}
                      <div className="pu-pcard-body">
                        <div className="pu-pcard-top">
                          <span className="pu-pcard-code">{item.product_code || "-"}</span>
                          <span className="pu-pcard-type">{item.product_type || "-"}</span>
                        </div>
                        <div className="pu-pcard-name" title={item.product_name || ""}>
                          {item.product_name || "-"}
                        </div>
                        <div className="pu-pcard-foot">
                          <div>
                            <div className="pu-pcard-price">
                              {toFixed(Number(item.price) || 0, 2)}
                            </div>
                            <div className="pu-pcard-sold">
                              Sold {(Number(item.sold) || 0).toLocaleString("en-US")}
                            </div>
                          </div>
                          <div className="text-nowrap">
                            <button
                              className="btn btn-sm btn-outline-dark rounded-pill me-1"
                              title="Edit"
                              onClick={() => this.OpenUpdate(item)}
                            >
                              <span className="icon">{"\uf044"}</span>
                            </button>
                            <button
                              className="btn btn-sm btn-outline-danger rounded-pill"
                              title="Delete"
                              onClick={() => this.Delete(item)}
                            >
                              <span className="icon">{"\uf2ed"}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            )}
          </div>

          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              page={page}
              count={Math.ceil(count / PAGE_SIZE) || 1}
              showFirstButton
              showLastButton
              onChange={(_, p) => this.Get(p)}
            />
          </div>
        </div>

        {/* ภาพขยายตอนเอาเมาส์ชี้ที่รูปสินค้า */}
        {preview && (
          <div className="pu-zoom" ref={this.zoom_ref} style={{ left: preview.x, top: preview.y }}>
            <img
              src={preview.src}
              alt={preview.name || "preview"}
              onError={this.handleImgError}
            />
            {preview.name ? <div className="pu-zoom-name">{preview.name}</div> : null}
          </div>
        )}

        {/* CREATE / UPDATE */}
        <Modal
          show={modal_create || modal_update}
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={closeModal}
          size="lg"
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">
                {modal_create ? "New product" : `Edit product ${product_code || ""}`}
              </div>
              <h5 className="fw-bold mb-0">
                {modal_create ? "Create" : "Update"} Product
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="pu-section">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Image
                  </div>
                  <div
                    className="rounded-4 overflow-hidden bg-light border mb-2"
                    style={{ width: "100%", aspectRatio: "1 / 1" }}
                  >
                    <img
                      alt="preview"
                      src={product_image || LOGOLARGE}
                      width="100%"
                      height="100%"
                      style={{ objectFit: "cover" }}
                      onError={this.handleImgError}
                    />
                  </div>
                  <label className="pr-label">Image URL</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="https://..."
                    onChange={(e) => this.setState({ product_image: e.target.value })}
                    value={product_image}
                  />
                  <div className="pu-hint">Paste a public image URL. Preview updates as you type.</div>
                </div>
              </div>
              <div className="col-12 col-md-8">
                <div className="pu-section">
                  <div className="pu-section-title">
                    <span className="icon">{""}</span>Product
                  </div>
                  {modal_update && (
                    <div className="mb-3">
                      <label className="pr-label">Code</label>
                      <input type="text" className="form-control pr-input" value={product_code} disabled />
                    </div>
                  )}
                  <div className="mb-3">
                    <label className="pr-label">Name{required}</label>
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="Product name..."
                      onChange={(e) => this.setState({ product_name: e.target.value })}
                      value={product_name}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="pr-label">Type</label>
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="e.g. shirt, bag, shoes"
                      onChange={(e) => this.setState({ product_type: e.target.value })}
                      value={product_type}
                    />
                  </div>
                  <div className="row">
                    <div className="col-6 mb-3">
                      <label className="pr-label">Price (฿){required}</label>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        className="form-control pr-input"
                        placeholder="0.00"
                        onChange={(e) => this.setState({ price: e.target.value })}
                        value={price}
                      />
                    </div>
                    <div className="col-6 mb-3">
                      <label className="pr-label">Sold</label>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        className="form-control pr-input"
                        placeholder="0"
                        onChange={(e) => this.setState({ sold: e.target.value })}
                        value={sold}
                      />
                    </div>
                  </div>
                  <div>
                    <label className="pr-label">Remark</label>
                    <textarea
                      className="form-control pr-input"
                      rows={3}
                      maxLength={500}
                      placeholder="Optional note (max 500 characters)"
                      onChange={(e) => this.setState({ remark: e.target.value })}
                      value={remark}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button className="btn btn-dark px-5 me-1 rounded-pill" onClick={this.CreateUpdate}>
              Submit
            </button>
            <button className="btn btn-outline-dark px-5 ms-1 rounded-pill" onClick={closeModal}>
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
